import { Injectable } from '@angular/core';
import { MIN_AIRPORT_SEARCH_LENGTH } from '../../constants/common/common.constants';

@Injectable({
  providedIn: 'root'
})
export class AirportSearchErrorService {
  private _searchErrorMessage = '';
  private _searchErrorMessageFromAEM = '';
  private _minSearchLength = MIN_AIRPORT_SEARCH_LENGTH;
  _errorFlag = false;

  get searchErrorMessage(): string {
    return this._searchErrorMessage;
  }

  setErrorMessageFromAEM(errorMessage: string): void {
    this._searchErrorMessageFromAEM = errorMessage;
  }

  clearError(): void {
    this._searchErrorMessage = '';
  }

  handleEmptyResults(resultCount: number, searchTerm: string): void {
    if (resultCount === 0 && searchTerm.length >= this._minSearchLength) {
      this._searchErrorMessage = this._searchErrorMessageFromAEM;
      this._errorFlag = true;
    } else {
      this._searchErrorMessage = '';
      this._errorFlag = false;
    }
  }

  handleApiError(searchTerm: string): void {
    if (searchTerm.length >= this._minSearchLength) {
      this._searchErrorMessage = this._searchErrorMessageFromAEM;
    }
  }

  reset(): void {
    this._searchErrorMessage = '';
    this._searchErrorMessageFromAEM = '';
    this._minSearchLength = MIN_AIRPORT_SEARCH_LENGTH;
  }
}
